/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Meta_DescriptionInputs */

const en_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming golf camps and clinics with Mark Egly in Des Moines, Iowa. Junior camps, adult beginner days, and short-game workshops.`)
};

const es_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos campamentos y clínicas de golf con Mark Egly en Des Moines, Iowa. Campamentos juniors, días para adultos principiantes y talleres de juego corto.`)
};

const de_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende Golfcamps und Kurse mit Mark Egly in Des Moines, Iowa. Junior-Camps, Anfängertage für Erwachsene und Kurzspiel-Workshops.`)
};

const zh_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly 即将在爱荷华州得梅因举办的高尔夫训练营和训练班：青少年训练营、成人初学者体验日和短杆技巧工作坊。`)
};

const ar_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معسكرات وورش غولف تدريبية قادمة مع Mark Egly في Des Moines, Iowa. معسكرات للناشئين، وأيام للمبتدئين الكبار، وورش اللعبة القصيرة.`)
};

const fr_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps et stages de golf à venir avec Mark Egly à Des Moines, Iowa. Camps juniors, journées pour adultes débutants et ateliers de petit jeu.`)
};

const vi_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các trại và lớp chuyên đề golf sắp tới với Mark Egly tại Des Moines, Iowa. Trại thiếu niên, ngày dành cho người lớn mới bắt đầu, và workshop lối chơi ngắn.`)
};

const sw_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kambi za gofu na mafunzo yajayo pamoja na Mark Egly huko Des Moines, Iowa. Kambi za vijana, siku za watu wazima wanaoanza, na warsha za mchezo mfupi.`)
};

const th_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แคมป์และคลินิกกอล์ฟที่กำลังจะมีขึ้นร่วมกับ Mark Egly ในเมืองดิมอยน์ รัฐไอโอวา ค่ายเยาวชน วันเริ่มต้นสำหรับผู้ใหญ่ และเวิร์กช็อปเกมสั้น`)
};

const bs_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predstojeći golf kampovi i kursevi s Markom Eglyjem u Des Moinesu, Iowa. Juniorski kampovi, dani za početnike i radionice kratke igre.`)
};

const ja_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines（Iowa）で開催される Mark Egly のゴルフキャンプ・クリニックのご案内。ジュニアキャンプ、大人の初心者向けデー、ショートゲームのワークショップ。`)
};

const ko_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa주 Des Moines에서 Mark Egly와 함께하는 골프 캠프와 클리닉 일정. 주니어 캠프, 성인 초보자의 날, 숏게임 워크숍.`)
};

const pt_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos acampamentos e clínicas de golfe com Mark Egly em Des Moines, Iowa. Acampamentos para jovens, dias para adultos iniciantes e workshops de jogo curto.`)
};

const it_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimi camp e clinic di golf con Mark Egly a Des Moines, Iowa. Camp junior, giornate per principianti adulti e workshop sul gioco corto.`)
};

const sv_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommande golfläger och kurser med Mark Egly i Des Moines, Iowa. Juniorläger, nybörjardagar för vuxna och workshoppar i närspel.`)
};

const nl_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komende golfkampen en clinics met Mark Egly in Des Moines, Iowa. Juniorkampen, beginnersdagen voor volwassenen en workshops voor het korte spel.`)
};

const da_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende golfcamps og kurser med Mark Egly i Des Moines, Iowa. Juniorcamps, begynderdage for voksne og workshops i det korte spil.`)
};

const nb_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende golfleirer og kurs med Mark Egly i Des Moines, Iowa. Juniorleirer, nybegynnerdager for voksne og workshops i kortspill.`)
};

const fi_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulevat golfleirit ja -kurssit Mark Eglyn kanssa Des Moinesissa, Iowassa. Juniorileirejä, aikuisten aloittelijapäiviä ja lähipelin työpajoja.`)
};

const pl_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadchodzące obozy i szkolenia golfowe z Markiem Eglym w Des Moines w stanie Iowa. Obozy dla juniorów, dni dla początkujących dorosłych i warsztaty krótkiej gry.`)
};

const ru_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящие гольф-лагеря и мастер-классы с тренером Mark Egly в Des Moines, Iowa. Лагеря для юниоров, дни для начинающих взрослых и семинары по короткой игре.`)
};

const tr_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa'da Mark Egly ile yaklaşan golf kampları ve eğitim programları. Gençlik kampları, yetişkinler için başlangıç günleri ve kısa oyun atölyeleri.`)
};

const hi_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa में Mark Egly के साथ आगामी गोल्फ कैंप और प्रशिक्षण सत्र। जूनियर कैंप, वयस्क शुरुआती खिलाड़ियों के लिए दिन और शॉर्ट-गेम कार्यशालाएँ।`)
};

const id_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamp dan kelas golf mendatang bersama Mark Egly di Des Moines, Iowa. Kamp junior, hari pemula dewasa, dan lokakarya permainan pendek.`)
};

const ms_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kem dan kelas golf akan datang bersama Mark Egly di Des Moines, Iowa. Kem junior, hari pemula dewasa dan bengkel permainan pendek.`)
};

const cs_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadcházející golfové kempy a kurzy s Markem Eglym v Des Moines v Iowě. Kempy pro juniory, dny pro dospělé začátečníky a workshopy krátké hry.`)
};

const el_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προσεχείς κατασκηνώσεις και σεμινάρια γκολφ με τον Mark Egly στο Des Moines της Iowa. Κατασκηνώσεις για νέους, ημέρες για ενήλικες αρχάριους και εργαστήρια κοντινού παιχνιδιού.`)
};

const he_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחנות גולף וסדנאות עם Mark Egly ב-Des Moines, Iowa: מחנות לנוער, ימי מתחילים למבוגרים וסדנאות משחק קצר.`)
};

const af_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komende gholfkampe en -kursusse met Mark Egly in Des Moines, Iowa. Juniorkampe, beginnersdae vir volwassenes en kortspel-werkswinkels.`)
};

const hu_events_meta_description = /** @type {(inputs: Events_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közelgő golftáborok és tanfolyamok Mark Eglyvel Des Moines-ban, Iowában. Junior táborok, kezdő napok felnőtteknek és rövid játék workshopok.`)
};

/**
* | output |
* | --- |
* | "Upcoming golf camps and clinics with Mark Egly in Des Moines, Iowa. Junior camps, adult beginner days, and short-game workshops." |
*
* @param {Events_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_meta_description = /** @type {((inputs?: Events_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_meta_description(inputs)
	if (locale === "de") return de_events_meta_description(inputs)
	if (locale === "zh") return zh_events_meta_description(inputs)
	if (locale === "ar") return ar_events_meta_description(inputs)
	if (locale === "fr") return fr_events_meta_description(inputs)
	if (locale === "vi") return vi_events_meta_description(inputs)
	if (locale === "sw") return sw_events_meta_description(inputs)
	if (locale === "th") return th_events_meta_description(inputs)
	if (locale === "bs") return bs_events_meta_description(inputs)
	if (locale === "ja") return ja_events_meta_description(inputs)
	if (locale === "ko") return ko_events_meta_description(inputs)
	if (locale === "pt") return pt_events_meta_description(inputs)
	if (locale === "it") return it_events_meta_description(inputs)
	if (locale === "sv") return sv_events_meta_description(inputs)
	if (locale === "nl") return nl_events_meta_description(inputs)
	if (locale === "da") return da_events_meta_description(inputs)
	if (locale === "nb") return nb_events_meta_description(inputs)
	if (locale === "fi") return fi_events_meta_description(inputs)
	if (locale === "pl") return pl_events_meta_description(inputs)
	if (locale === "ru") return ru_events_meta_description(inputs)
	if (locale === "tr") return tr_events_meta_description(inputs)
	if (locale === "hi") return hi_events_meta_description(inputs)
	if (locale === "id") return id_events_meta_description(inputs)
	if (locale === "ms") return ms_events_meta_description(inputs)
	if (locale === "cs") return cs_events_meta_description(inputs)
	if (locale === "el") return el_events_meta_description(inputs)
	if (locale === "he") return he_events_meta_description(inputs)
	if (locale === "af") return af_events_meta_description(inputs)
	if (locale === "hu") return hu_events_meta_description(inputs)
	return en_events_meta_description(inputs)
});